import { Modal, Image, Button } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { getImgsInRelatePagesByDocid, updateQuestionUrl } from '../../requests/question';
import circle from '../../assets/images/circle.png';
import { CheckCircleTwoTone } from '@ant-design/icons';
import './ImageDisplay.scss';

function ImageSelector(props) {
    const { imgs, selectedImgChange } = props;
    const [imgList, setImgList] = useState(imgs);
    const handleCircle = (index) => {
        const tempImgList = imgList.slice();
        tempImgList[index] = { ...tempImgList[index], selected: true };
        setImgList(tempImgList);
        selectedImgChange(tempImgList.filter(x => x.selected).map(x => x.img));
    }
    const handleChecked = (index) => {
        const tempImgList = imgList.slice();
        tempImgList[index] = { ...tempImgList[index], selected: false };
        setImgList(tempImgList);
        selectedImgChange(tempImgList.filter(x => x.selected).map(x => x.img));
    }

    return (
        <Image.PreviewGroup
            preview={{
                onChange: (current, prev) =>
                    console.log(`current index: ${current}, prev index: ${prev}`),
            }}
        >
            {imgList.map((ele, index) => {
                return (<div className='selector-container' key={index}>
                    <Image width={200} src={ele.img} />
                    {!ele.selected ? <img className='icon' onClick={() => handleCircle(index)} src={circle} style={{ width: '24px' }} /> :
                        <CheckCircleTwoTone className='icon' onClick={() => handleChecked(index)} style={{ fontSize: '24px' }} />}
                </div>
                )
            })}
        </Image.PreviewGroup>
    );
}

function ImageDisplay(props) {
    const { isEdit, question_id, document_id, page } = props;
    const [imgList, setImgList] = useState(props.imgList || []);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [imgsInSelector, setImgsInSelector] = useState([]);
    const selectedImgsRef = useRef([]);

    const showModal = async () => {
        const imgsInRelatePages = await getImgsInRelatePagesByDocid(document_id, page);
        const i = imgsInRelatePages.map(ele => {
            if (imgList.indexOf(ele) !== -1) {
                return { img: ele, selected: true }
            } else {
                return { img: ele, selected: false }
            }
        })
        setImgsInSelector(i);
        setIsModalOpen(true);
    };

    const handleOk = async () => {
        setImgList(selectedImgsRef.current);
        await updateQuestionUrl(question_id, selectedImgsRef.current);
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        selectedImgsRef.current = [];
    };

    const handleChangeSelectedImg = (imgs) => {
        selectedImgsRef.current = imgs;
    }
    return (<div>
        <Image.PreviewGroup>
            {imgList.map((ele, index) => <Image key={index} width={200} src={ele}
                fallback="data:image/png;base64,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"
            />)}
        </Image.PreviewGroup>
        {isEdit ? <div>
            <Button onClick={showModal}>Select Image</Button>
        </div> : null}
        {isEdit ? <Modal centered={true} title="Select Image" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <ImageSelector imgs={imgsInSelector} selectedImgChange={handleChangeSelectedImg} />
        </Modal> : null}
    </div>);
}

export default ImageDisplay;